Object.defineProperty(exports,"__esModule",{value:true});exports.default=null;

var isDev=exports.isDev=function isDev(){return(
global.__DEV__||
process.env.NODE_ENV==='dev'||
process.env.NODE_ENV==='development');};